module.exports = __webpack_public_path__ + "img/bg-2.8097527c.jpeg";